import { Build } from '@stencil/core';

const configStore = new Map<string, any>();

function extractConfig() {
  if (Build.isBrowser) {
    return TYPO3.settings || { TS: {}, settings: {} };
  } else if (Build.isServer) {
    return JSON.parse(document.querySelector('body').getAttribute('data-nlx-ssr-settings')) || {};
  }
  return { TS: {}, settings: {} };
}

let { TS, ...settings } = extractConfig();
Object.entries(TS || {}).forEach(entry => {
  configStore.set(entry[0].replace('.', ''), entry[1]);
});
Object.entries(settings || {}).forEach(entry => {
  configStore.set(entry[0], entry[1]);
});

export function getConfig(path: string, fallback?: any): any {
  let value;
  if (path.includes('.')) {
    let [key, ...paths] = path.split('.');
    value = (paths || []).reduce((value, key) => value[key], configStore.get(key) ?? '');
  } else {
    value = configStore.get(path);
  }
  return value !== undefined ? value : fallback;
}

export function hasConfig(key: string) {
  return configStore.has(key);
}
